import CustomerDetailsLink from './CustomerDetailsLink';

export default CustomerDetailsLink;
